import React, {Component} from 'react'
import LinkWithTooltip from '../../tooltip';

class Icon extends Component {

  constructor(props) {
    super(props);

    this.state = {
      iconList: faIconList,
      listOpen: false,
      icon: '',
      filterText: ''
    };
  }

  componentDidMount(){
    this.setState({
      icon: this.props.input.value
    })
  }

  onClickHandle(event){
    event.preventDefault();
    const {listOpen} = this.state;
    this.setState({listOpen:!listOpen})
  }

  setIcon(icon){
    const {listOpen} = this.state;
    this.setState({
      icon: icon,
      listOpen: !listOpen
    });
  }

  componentWillReceiveProps(nextProps){
      this.setState({ icon: nextProps.input.value });
  }

  handleIconFilter(e){
    e.preventDefault();
    this.setState({
      filterText: e.target.value
    })
  }

  render(){
    const { input: { value, onChange, name }, params } = this.props
    var listClassName = 'sp-pagebuilder-fontawesome-icon-chooser';
    if (this.state.listOpen) {
      listClassName = listClassName + ' open';
    }

    if (this.state.icon != '') {
      listClassName = listClassName + ' sp-pagebuilder-has-fa-icon';
    }


    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <div className={listClassName}>
          <div className="sp-pagebuilder-fontawesome-icon-input" onClick={ this.onClickHandle.bind(this) }>
              {
                this.state.icon
                ?
                <div><i className={"fa "+this.state.icon} /> <span>{ this.state.icon }</span></div>
                :
                <div className="sppb-icon-placeholder">Select Icon...</div>
              }
              
              {/* <span className={"fa "+this.state.icon}>{ this.state.icon }</span> */}
            <a
              className="sp-pagebuilder-remove-fa-icon"
              href="#"
              onClick={ (e) => {
                e.preventDefault();
                var data = '';
                onChange(data);
                this.setIcon('');
              }}
            >
              <i className="fa fa-times"></i>
            </a>
            <i className="fa fa-caret-up"></i>
            <i className="fa fa-caret-down"></i>
          </div>
          <div className="clearfix sp-pagebuilder-fontawesome-dropdown">
            <div className="sp-pagebuilder-fontawesome-search">
              <input type="text" onChange={ this.handleIconFilter.bind(this) } autoComplete="off" />
            </div>
            <ul className="sp-pagebuilder-fontawesome-icons">
            {
              this.state.listOpen &&
              this.state.iconList.map( (name, index)=> {
                if (this.state.filterText != '' ) {
                  if (name.toLowerCase().indexOf(this.state.filterText.toLowerCase()) === -1) {
                    return;
                  }
                }
                var classIconName = 'fa '+ name;
                return (
                  <li key={index} onClick = { (e) => {
                        e.preventDefault();
                        this.setIcon(name);
                        onChange(name);
                        
                      }}
                      className="sp-pagebuilder-fa-list-icon"
                  >
                    <div>
                      <div>
                        <div>
                          <i className={classIconName}></i>
                        </div>
                      </div>
                    </div>
                  </li>
                )
              })
            }
            </ul>
          </div>
        </div>
        
      </div>
    )
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Icon.js